module.exports = __webpack_public_path__ + "static/media/instagram.f297a6ce.svg";